<template>
	<div class="operation-fraction-component">
		<template v-if="operator==='fad'">			
			<span class="num" v-html="fract.num"></span>
			<span class="divide-operator">÷</span>
			<span class="den" v-html="fract.den"></span>
			<span class="equal-sign">=</span> 
		</template>
		<fraction :fraction="fract.corrected"></fraction>
		<template v-if="fract.num && fract.den && !fract.isSimplificated">
			<span class="equal-sign">=</span>
			<fraction :fraction="fract.simplification" class="simplification"></fraction>
			<span class="equal-sign">=</span> 
			<fraction :fraction="fract.simplificated"></fraction>
		</template>
	</div>
</template>

<script>
	/**
	 * component wich represent fraction
	 */

	 import Fraction from '../scripts/Fraction.js';
	 import FractionComponent from '../FractionComponent.vue'

	export default{
		props:{
			fraction:{type:[Object, Array], required: false},
			operator:{type:String, required: false, default: 'fract'},
			deep:{type: Number, required: false, default: 0},
		},
		components: {fraction: FractionComponent},
		nam:'fraction',
		data(){
			return{
				denominator:"",
				numerator:"",
				fract:{},
			}
		},
		created(){
			this.fract=this.fraction instanceof Array?new Fraction(...this.fraction):new Fraction(this.fraction);
		}
	};
</script>